import { render, staticRenderFns } from "./AdminInvoiceQueryHistory.vue?vue&type=template&id=3536551e&scoped=true"
import script from "./AdminInvoiceQueryHistory.vue?vue&type=script&lang=js"
export * from "./AdminInvoiceQueryHistory.vue?vue&type=script&lang=js"
import style0 from "./AdminInvoiceQueryHistory.vue?vue&type=style&index=0&id=3536551e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3536551e",
  null
  
)

export default component.exports